export default {
  center: {
    textAlign: 'center'
  },
  right: {
    textAlign: 'right'
  }
}
